module.exports = __webpack_public_path__ + "static/media/tres-logos-fn-azul-short2.0a617e19.svg";